import { WEEK_DAYS } from "../constants/AppConst";

export function isSameDay(timestamp: number): boolean {
  const date1 = new Date(timestamp); // convert từ timestamp
  const date2 = new Date(); // ngày hiện tại

  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() && // chú ý: getMonth() trả về 0-11
    date1.getFullYear() === date2.getFullYear()
  );
}

export function getTodayValue(): number {
  const day = new Date().getDay(); // 0=Sun, 1=Mon...
  return day === 0 ? 7 : day; // Convert về 1–7 (Mon–Sun)
}

export const formatRecurringDays = (days: number[]): string => {
  if (!days || days.length === 0) return "";

  const labels = days.map((day) => WEEK_DAYS.find((d) => d.value === day)?.label).filter(Boolean);

  return `${labels.join(", ")} hàng tuần`;
};
